import { createEnvironment } from '@payflip/utils';
import { AuthConfig } from '@payflip/web/auth';

const prefix = 'NX_PUBLIC_';

const optionalKeysWithDefaultValue = [
  {
    key: 'IS_PARTNER',
    defaultValue: 'false'
  },
  {
    key: 'THEME',
    defaultValue: 'payflip'
  },
  {
    key: 'GRAPHQL_API_URI',
    defaultValue: 'http://localhost:4400/graphql'
  },
  {
    key: 'REST_API_URI',
    defaultValue: 'http://localhost:4400/api'
  },
  {
    key: 'AUTH0_CLIENT_ID',
    defaultValue: 'Guq3uAuw1TJ7xXmoePUaAUBk2TzqWquj'
  },
  {
    key: 'AUTH0_DOMAIN',
    defaultValue: 'staging.auth.payflip.be'
  },
  {
    key: 'AUTH0_AUDIENCE',
    defaultValue: 'https://app-api.payflip.be'
  },
  {
    key: 'AUTH0_CONNECTION',
    defaultValue: ''
  },
  {
    key: 'AUTH0_LOGOUT_REDIRECT_URL',
    defaultValue: 'http://localhost:4300'
  },

  {
    key: 'STRAPI_GRAPHQL_API_URI',
    defaultValue: 'https://cms.payflip.be/graphql'
  },
  {
    key: 'STRAPI_API_TOKEN',
    defaultValue:
      '1f769d9cc5566b5ce83163d089ab7183d30ea618b79f7597a01f5001325c34a55bddd4acf9555bc2e27714ac979fc65cb1515b4ee8e434c8c5e6f1d061a2385ae0ae0d1a33a4ed398582d8aa8566f414c5071981e30ab365c0ba6c0f68f775be525e194ff9f26d33ca361bdaad2c487874fe6fee00d8546acfa90d00a4b57092'
  },
  {
    key: 'INTERCOM_APP_ID',
    defaultValue: 'false'
  },
  {
    key: 'HELLO_SIGN_CLIENT_ID',
    defaultValue: 'eaf9ad8718e615d97e2b420689abecb7'
  },
  {
    key: 'LAUNCH_DARKLY_CLIENT_ID',
    defaultValue: '63d8e6a606bcaa12bdc19b5e'
  },
  {
    key: 'ADMIN_APP_URL',
    defaultValue: 'http://localhost:4500'
  }
] as const;

const mandatoryKeys = [] as const;

export const environment = createEnvironment(
  mandatoryKeys,
  optionalKeysWithDefaultValue,
  prefix
);

export const authConfig: AuthConfig = {
  domain: environment.AUTH0_DOMAIN,
  clientId: environment.AUTH0_CLIENT_ID,
  audience: environment.AUTH0_AUDIENCE,
  connection:
    environment.AUTH0_CONNECTION === 'false'
      ? undefined
      : environment.AUTH0_CONNECTION,
  logoutUrl: environment.AUTH0_LOGOUT_REDIRECT_URL,
  isPartner: environment.IS_PARTNER === 'true'
};
